import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Sticky from 'Components/Sticky';
import ActionLoader from 'Components/ActionLoader';
import RFQStatusBar from 'Components/RFQStatusBar';

import RFQDetails from './Components/RFQDetails';
import BiddingDetailsCard from './Components/BiddingDetailsCard';
import CargoInformation from './Components/CargoInformation';
import TripTable from './Components/TripTable';
import AddTrip from './Components/AddTrip';
import MultiModeAddTrip from './Components/MultiModeAddTrip';
import TransportersCard from './Components/TransportersCard';
import DocumentsCard from './Components/DocumentsCard';
import RFQBottomSticky from './Components/RFQBottomSticky';
import RFQSwitchTypeBar from './Components/RFQSwitchTypeBar';
import Preview from './Components/RFQPreview';
import BiddingDetails from './Components/AddTrip/BiddingDetails';

import moment from 'moment';
import LadyImage from 'Icons/lady.png';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import { scroll, isAdaniWilmar } from 'Utils/';
import { getUser , getToken, setCookie } from 'Utils/storage';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { GREEN_PLY, HIKAL, CARGIL, ROQUETTE, CENTURY_PLY, GALAXY_SURFACE, EMAMI, MITSUI, BEAM, DEEPAK_PHENOLICS_SAP } from 'Constants/commonConstants';
import Procurement from 'Pages/Procurement';

import {
   GET_GROUPS_AND_TRANSPORTERS,
   CREATE_RFQ,
   SET_PREVIOUS_RFQ_VIEW,
   GET_TRIPS,
   ADD_TRIP,
   UPLOAD_DOCUMENT,
   SET_RFQ_ACTIVE_VIEW,
   ADD_TRIP_ADDING,
   DISCARD_RFQ,
   DELETE_TRIP,
   GET_RFQ_DETAIL,
   GET_RFQ_DETAIL_SUCCESS,
   SET_NEXT_RFQ_VIEW,

   DOWNLOAD_TRIPS_TEMPLATE,
   UPLOAD_TRIPS,
   GET_QBR,

   GET_VEHICLE_TYPES,
   GET_VEHICLE_BODY_TYPES,
   GET_BUSINESS_VOLUMES,
   TOAST_ERROR,

   GET_AUTO_SUGGEST_LOCATIONS,
   GET_NETWORK_DETAILS,
   DELETE_ADDED_TRIP,

   GET_SECONDARY_TO_LOCATION,
   GET_SECONDARY_UPTO_KM_LIST,
   GET_MOVEMENTS,
   GET_MODES,
   GET_ZONES,
   GET_COURIER_SLABS,
   GET_COURIER_TRIPS,
   POST_COURIER_TRIPS,
   GET_BRANCHES,
   GET_CURRENCY_DETAILS,
   GET_MULTI_MODE_CONTAINER_LIST,
   GET_MULTI_MODE_MOVEMENT_TYPE_LIST,
   GET_PLANT_LOCATION_LIST,
   GET_DEPOT_LOCATION_LIST,
   GET_CHA_LIST,
   GET_CURRENCY_TYPES,
   GET_LOCATION_WITH_PINCODE,
   GET_INCOTERMS_LIST,
   GET_COST_HEADS_LIST,
   GET_PRICING_BASIS,
   GET_PACKING_TYPES,
   GET_FUEL_TYPES,
   GET_PAYMENT_CYCLES,
   GET_PRODUCT_CATEGORIES,
   GET_SPOT_CONTRACT_REASONS,
   GET_CONTRACT_TENURE_LIST,
   GET_FTL_CONTRACT_TYPE,
   GET_ZONE_WISE_DETAILS,
   GET_CLUSTER_DETAILS,
   UPLOAD_EXTISTING_TRIPS_REMARKS,
   DOWNLOAD_EXTISTING_TRIPS_REMARKS_TEMPLATE,
   POST_CONTAINER_TRIPS,
   GET_SLABS,
   GET_CONSIGNEE_DETAILS_BY_NAME,
   GET_SERVICE_MODE,
   GET_PAYMENT_TERMS,
   GET_VENDOR_WITH_MATERIAL_CODE,
   DOWNLOAD_UPLOADED_FILE,
   ADMIN_UPDATE_RFQ
} from 'Constants/actionConstants';
import CardT4 from 'Pages/SupplierRFQCreateOrUpdateRequest/CardT4';
import CardT5 from 'Pages/SupplierRFQCreateOrUpdateRequest/CardT5';
import { isBeamS, isCoromandel, isDesmet, isDesmetSupplier } from 'Utils/index';
import { Spacer } from 'Components/Common/Spacer/index';
import { CardWrapper } from 'Components/Common/Card/index';
import { ContactDetails } from 'Pages/SupplierRFQCreateOrUpdateRequest/CardT3';
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";
import { screenInfoDetails } from 'Constants/screenInfoDetailsConstants';
import Tk11Details from 'Components/Tk11Details/index';

class AdminRFQView extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         rfq: props.rfq,
         offset: 0,
         rfqDetailsSubmitted: false,
         cargoDetailsSubmitted: false,
         transporterDetailsSubmitted: false,
         isSuccessfull: false,
         customLocationsSearch: [],
         uploadTripsCount: 0,
         disableSubmitTrips: false,
         selectedSubPlant: [],
         courierTripsList: [],
         courierOtherCharges: [],
         additionalZones: [],
         selectedContracting:[],
         selectedContractCategory:[],
         disposalProductTrips: [],
         containerTrips: [],
         warehouseTrips: [],
         adminRfqName: '',
         showUpdateModal: false,
         adminRemark: '',
         originalRfqValues: null
      }
      this.viewMode = true;
   }

   componentWillReceiveProps(nextProps, props) {
      this.setState({
         isSuccessfull: false
      });
      if (!this.props.rfq && nextProps.rfq) {
         this.setState({
            originalRfqValues: {
               rfq_name: nextProps.rfq.rfqDetails.name,
               pricingBasis: nextProps.rfq.biddingDetails.pricingBasis,
               paymentCycle: nextProps.rfq.biddingDetails.paymentCycle
            },
            adminRfqName: nextProps.rfq.rfqDetails.name || ''
         });
      }
      if((nextProps.selectedNavBranch || {}).branch_id && ((nextProps.selectedNavBranch || {}).branch_id !== (this.props.selectedNavBranch || {}).branch_id)) {
         this.getConstansValues((nextProps.selectedNavBranch || {}).branch_id);
      }
   }

   getConstansValues = (branchId = '') => {
      const { match, dispatch } = this.props;
      const user = getUser();
      const params = {
         rfqType: match.params.type && Number(match.params.type ),
         companyId: user.companyId,
         branchId: branchId ? branchId : user.branchId
      }
      dispatch({ type: GET_VEHICLE_TYPES, params });
      dispatch({
         type: GET_PRICING_BASIS,
         data: params
      });
      dispatch({
         type: GET_PACKING_TYPES,
         data: params
      });
      dispatch({
         type: GET_PAYMENT_CYCLES,
         data: params
      });
      dispatch({
         type: GET_PRODUCT_CATEGORIES,
         data: params
      })
   }

   uploadTrips = (file) => {
      const { dispatch, match, rfq } = this.props;
      dispatch({
         type: UPLOAD_TRIPS,
         file,
         params: {
            rfqId: match.params.id,
            type: rfq.rfqDetails.serviceType === 3 ? 1 :(rfq.type==2 || rfq.type==5) ? 3 : 2,
            rfqType: match.params.type,
            withPincode: rfq.rfqDetails.withPincode
         },
         onSuccess: (data) => {
            if (data && data.count && (data.count > 50 || +rfq.type === 2 || +rfq.type === 5)) {
               setTimeout(() => {
                  if(rfq.rfqDetails.serviceType === 3) {
                     this.getCourierTrips();
                  } else {
                     this.fetchTrips({ offset: 0, limit: 1000 });
                  }
               }, 10000);
               this.setState({ uploadTripsCount: data.count - 1, disableSubmitTrips: true });
            } else {
               if(rfq.rfqDetails.serviceType === 3 && +rfq.type === 4) {
                  this.getCourierTrips();
               } else {
                  this.fetchTrips({ offset: 0, limit: 1000 });
               }
            }
         }
      });
   }
   downloadTrips = () => {
      const { dispatch, match, rfq } = this.props;
      let that = this;
      dispatch({
         type: DOWNLOAD_TRIPS_TEMPLATE,
         params: {
            type: ((rfq.type == 3) ? 9 : ((getUser().showPinCodeDetails) ? 8 : (rfq.rfqDetails.serviceType === 3 ? 1 : (rfq.type==2 || rfq.type==5) ? 3 : 2))),
            rfqId: match.params.id,
            rfqType: match.params.type,
            withPincode: rfq.rfqDetails.withPincode
         },
         onSuccess: (data) => {
            if (data.url !== that.state.uploadTripsUrl) {
               that.setState({
                  uploadTripsUrl: data.url,
                  isSuccessfull: true,
               }, () =>{
                  that.uploadTripsButton.click();
               });
            } else if(data.url && rfq.rfqDetails.serviceType === 3) {
               that.uploadTripsButton.click();
            }else if (that.state.isSuccessfull) {
                    that.uploadTripsButton.click();
           }
         }
      });
   }
   fetchTrips = (filters = {}) => {
      const { dispatch, rfq } = this.props;
      if(rfq.rfqDetails.serviceType === 3) {
         this.getCourierTrips(filters);
      } else {
         dispatch({
            type: GET_TRIPS,
            params: {
               rfqId: rfq.id,
               rfqType: rfq.type,
               ...filters
            },
            onSuccess: ((data) => {
               const count = this.state.uploadTripsCount - 1;
               const tripCount = ((+rfq.type === 2 ||  +rfq.type === 5) && +rfq.rfqDetails.multiLevelMovementType === 2) ? data.actuall_trips_count : data.trips_count;
               if ((count > 0 || (count === tripCount) || tripCount === 1 ) && rfq.type !== 9 ) {
                  if (tripCount < count) {
                     this.fetchTrips();
                  }
                  this.setState({
                     disableSubmitTrips: (tripCount < count)
                  });
               }
            })
         });
      }
   }
   addTrip = (tripData, saveAndKeepAdding, isCopy) => {
      const { dispatch, trip, rfq, addingTrip } = this.props;
      const { offset } = this.state;
      const data = {
         trip_id: (trip && !isCopy) ? trip.id : undefined,
         rfq_id: rfq.id,
         trips: rfq.type === 6 ? [...tripData] : [tripData],
         parent_trip_id: trip && trip.id ? trip.parentTripId : undefined,
      }
      dispatch({
         type: ADD_TRIP,
         data,
         params: {
            rfqId: rfq.id,
            rfqType: rfq.type
         },
         additionalParams: {
            rfqType: rfq.type
         },
         saveAndKeepAdding,
         onError: ((data) => {
            this.setState({ isTripExists: data });
         })

      });
   }

   deleteAddedTrip = (trip) => {
      const { dispatch, rfq } = this.props;
      const { offset } = this.state;
      const data = {
         tripIdList: [trip.id]
      }
      dispatch({
         type: DELETE_ADDED_TRIP,
         data,
         params: {
            rfqId: rfq.id,
            limit: 1000,
            offset
         }
      });
   }

   resetTripStatus = (val) => {
      this.setState({ isTripExists: val });
   }

   deleteTrip = (trip) => {
      const { dispatch, rfq } = this.props;
      dispatch({
         type: DELETE_TRIP,
         data: {
            tripId: trip.id,
            parentTripId: trip.parentTripId || undefined,
         },
         params: {
            rfqId: rfq.id,
            limit: 1000,
            offset: this.state.offset
         }
      })
   }
   searchGroupsAndTransporters = (search, type = 2, isMultimode, isWarehouse, movementType) => {
      const { dispatch, match } = this.props;
      let branchId;
      const branchLocalName = localStorage.getItem('branchDetail');
      const name = (branchLocalName && branchLocalName.length > 0) ? JSON.parse(localStorage.getItem('branchDetail')) : '';
      dispatch({
         type: GET_GROUPS_AND_TRANSPORTERS,
         params: {
            search,
            branchId: name.branch_id,
            type,
            isMultimode: isMultimode || undefined,
            isWarehouse: (match.params.type === 7) && true || isWarehouse || undefined,
            rfqType: match.params.type,
            movementType: movementType || undefined
         }
      })
   }
   setNextView = () => {
      const { dispatch, activeView, trips, rfq, allSubPlants, courierZones } = this.props;
      const { selectedSubPlant } = this.state;
      const branchLocalName = JSON.parse(localStorage.getItem('branchDetail'));
      const rfqData = rfq.getApiData();
      const isTransporterDocumentsMandatory = (rfq.type === 6) ? rfq.rfqDetails.multiLevelMovementType === 1 : true;
      const isCargil = CARGIL.includes(rfq.companyId);
      const isMitsui = MITSUI.includes(rfq.companyId);
      const isGalaxySurface = GALAXY_SURFACE.includes(rfq.companyId);
      const isCenturyPly = CENTURY_PLY.includes(rfq.companyId);
      const isSapDPL = DEEPAK_PHENOLICS_SAP.includes(rfq.companyId);
      const isBEAMS = BEAM.includes(rfq.companyId);
      if (![8, 9].includes(rfq.type) && (activeView === 1 && (!((isAdaniWilmar() || isSapDPL) ? rfq.rfqDetails.fuelTypes : true) || ((isGalaxySurface || rfq.type === 10) ?false : isDesmet()?false:!rfq.cargoInfo.packingType) || ((rfq.type === 1 && isAdaniWilmar()) ? !rfq.rfqDetails.contractType : false) || ((rfq.type === 1 && isAdaniWilmar() && rfq.rfqDetails.contractType === 5) ? !rfq.rfqDetails.otherRemarks : false) ||  ((rfq.type === 2 && ['737---'].includes(getUser().companyId)) ? !rfq.cargoInfo.productCategory : false) || !(rfq.cargoInfo.cargoDetails || []).length || !rfq.rfqDetails.contractTenureTo) || (rfq.type != 10 && isTransporterDocumentsMandatory && !rfq.isAllTransporters && !rfq.groups.length && !rfq.transporters.length) || (  isDesmet()?false:isTransporterDocumentsMandatory && !rfq.documents.length) || (![6,10].includes(rfq.type) && !rfq.biddingDetails.pricingBasis) || !rfq.biddingDetails.to || !(rfq.biddingDetails.to > rfq.biddingDetails.from) || ((isCargil || isMitsui||isBEAMS) ? false : !(rfq.biddingDetails.paymentCycle && rfq.biddingDetails.paymentCycle > 0)) || (!((CARGIL.includes(getUser().companyId) && rfq.rfqDetails.movementTypeName === 'Spot') ? rfq.rfqDetails.spotContractReason : true)) || !(isSapDPL ? (rfq.cargoInfo.productCategory || []).length > 0 : true))) {
         if (!rfq.rfqDetails.contractTenureTo || !(isAdaniWilmar() ? rfq.rfqDetails.fuelTypes : true) || !((CARGIL.includes(getUser().companyId) && rfq.rfqDetails.movementTypeName === 'Spot') ? rfq.rfqDetails.spotContractReason : true)) {
            scroll(this.rfqDetailsRef.offsetTop + 200);
         } else if (((isGalaxySurface || isDesmet()) ? false : !rfq.cargoInfo.packingType) || !(rfq.cargoInfo.cargoDetails || []).length || ((rfq.type === 2 && ['737---'].includes(getUser().companyId)) ? !rfq.cargoInfo.productCategory : false) || (isSapDPL ? (rfq.cargoInfo.productCategory || []).length == 0 : false)) {
            scroll(this.cargoDetailsRef.offsetTop + 200)
         } else if (((rfq.type === 10) ? false : !rfq.biddingDetails.pricingBasis) || !rfq.biddingDetails.to || !(rfq.biddingDetails.to > rfq.biddingDetails.from) ||((isCargil || isMitsui||isBEAMS) ? false : !(rfq.biddingDetails.paymentCycle && rfq.biddingDetails.paymentCycle > 0))) {
            scroll(this.biddingDetailsRef.offsetTop + 200)
         } else if (!isDesmet() && !rfq.documents.length) {
            scroll(this.documentsRef.offsetTop + 200)
         } else if (rfq.type != 10 && !rfq.isAllTransporters && !rfq.groups.length && !rfq.transporters.length) {
            scroll(this.transporterDetailsRef.offsetTop + 200)
         }
         this.setState({
            cargoDetailsSubmitted: true,
            rfqDetailsSubmitted: true,
            transporterDetailsSubmitted: true,
            documentsSubmitted: true,
            biddingDetailsSubmitted: true
         });
         return;
      } else if(rfq.type == 9 && activeView === 1 && (!rfq.documents.length || !rfq.biddingDetails.to || !(rfq.biddingDetails.to > rfq.biddingDetails.from))) {
         if (!rfq.biddingDetails.to || !(rfq.biddingDetails.to > rfq.biddingDetails.from)) {
            scroll(this.biddingDetailsRef.offsetTop + 200)
         } else if (!isDesmet() && !rfq.documents.length) {
            scroll(this.documentsRef.offsetTop + 200)
         }
         this.setState({
            rfqDetailsSubmitted: true,
            documentsSubmitted: true,
            biddingDetailsSubmitted: true
         });
         return;
      } else if (isAdaniWilmar() && (activeView === 1 || activeView === 3) && (!branchLocalName.branch_id || branchLocalName.branch_id === getUser().companyId)) {
         dispatch({
            type:TOAST_ERROR,
            duration: 3,
            message: 'Please Select A Branch From The Navbar'
         });
         return;
      } else if ((isAdaniWilmar() || isCenturyPly || isSapDPL) && (activeView === 1 || activeView === 3) && allSubPlants.length > 0 && rfq.subplant_name.length === 0) {
         if(this.rfqDetailsRef) {
            scroll(this.rfqDetailsRef.offsetTop + 200)
            this.setState({
               rfqDetailsSubmitted: true
            });
         } else {
            this.toggleConfirmation();
            dispatch({
               type:TOAST_ERROR,
               duration: 3,
               message: 'Please Select A Sub Plant'
            });
         }
         return;
      }
      else if (activeView === 1 && (rfq.type === 2 || rfq.type === 5 || rfq.type === 6) && !rfq.rfqDetails.multiLevelMovementType) {
         scroll(this.rfqDetailsRef.offsetTop + 200)
         this.setState({
            rfqDetailsSubmitted: true
         });
         return;
      }
      else if (activeView === 1 && rfq.type === 5 && !rfq.rfqDetails.shippingType) {
         scroll(this.rfqDetailsRef.offsetTop + 200)
         this.setState({
            rfqDetailsSubmitted: true
         });
         return;
      }
      else if(![6,8, 9].includes(rfq.type) && (activeView === 1 || activeView === 3) && (rfq.minimumBiddersToCreateRfq && ((((rfqData.docs_and_transporters || {}).transporters || {}).transporter_ids || []).length < rfq.minimumBiddersCountToCreateRfq))) {
         if(this.transporterDetailsRef) {
            scroll(this.transporterDetailsRef.offsetTop + 200)
            this.setState({
               transporterDetailsSubmitted: true
            });
         } else {
            this.toggleConfirmation();
            dispatch({
               type:TOAST_ERROR,
               duration: 3,
               message: `Minimum Transporters To Be Selected ${rfq.minimumBiddersCountToCreateRfq}`
            });
         }
         return;
      }
      else if (![8, 10].includes(rfq.type) && rfq.rfqDetails.serviceType !== 3 && activeView === 2 && (trips || []).length === 0) {
         dispatch({
            type: TOAST_ERROR,
            message: 'Please add atleast one trip'
         });
         return
      }
      if(activeView === 2 && rfq && rfq.type == 10 &&  this.state.containerTrips.length === 0) {
         dispatch({
            type: TOAST_ERROR,
            message: 'Please add atleast one trip'
         });
         return
      }
      if (isCoromandel() && activeView === 1 && rfq && !rfq.rfqDetails.tk11_type) {
         dispatch({
            type: TOAST_ERROR,
            message: 'Please Select Atleast One Tk11 Type'
         });
         return
      }
      if (isCoromandel() && activeView === 1 && rfq && !rfq.rfqDetails.sales_organisation_type) {
         dispatch({
            type: TOAST_ERROR,
            message: 'Please Select Atleast One Sales Organisation Type'
         });
         return
      }
      if (this.viewMode) {
         dispatch({
            type: SET_NEXT_RFQ_VIEW
         });
         if (activeView === 1) {
            if(rfq.rfqDetails.serviceType === 3) {
               this.getCourierTrips();
            } else {
               if([9].includes(rfq.type)) {
                  dispatch({
                     type: GET_GROUPS_AND_TRANSPORTERS,
                     params: {
                        type: 24
                     }
                  })
               }
               if(![10].includes(rfq.type)) {
                  dispatch({
                     type: GET_TRIPS,
                     params: {
                        rfqId: rfq.id,
                        rfqType: rfq.type,
                        limit: 1000,
                        offset: 0
                     }
                  })
               } else if(activeView === 2 && rfq.type === 8) {
                  if(this.state.warehouseTrips.length > 0)
                     this.submitRFQ(true);
               }
            }
         }
         return;
      }
      if (activeView === 3) {
         rfq.setIsDraft(false);
      } else {
         rfq.setIsDraft(true);
      }
      if(rfq.type === 10 && (activeView === 2 || activeView === 3) && this.state.containerTrips.length > 0) {
         const cTrips = ((this.state.containerTrips || [])[0] || {});
         dispatch({
            type: POST_CONTAINER_TRIPS,
            data: {
                rfq_id: rfq.id,
                container_trip_type: cTrips.container_trip_type,
                container_type_name: cTrips.container_type_name,
                trips: this.state.containerTrips
            }
         })
      }
      if((activeView === 2 || activeView === 3) && rfq.rfqDetails.serviceType === 3) {
         this.addCourierTrips();
      } else {
         if(activeView === 2 && rfq.type === 8 && this.state.warehouseTrips.length === 0) {
            dispatch({
               type: TOAST_ERROR,
               message: 'Please add atleast one material details'
            })
         } else if(rfq.type === 9 && activeView === 2) {
               this.postDisposalMaterialTrips();
            } else {
               dispatch({
                  type: CREATE_RFQ,
                  data: rfq.getApiData(),
                  rfq,
                  onSuccess: () => {
                     if((isAdaniWilmar() || isCargil) && activeView === 1) {
                        if([9].includes(rfq.type)) {
                           dispatch({
                              type: GET_GROUPS_AND_TRANSPORTERS,
                              params: {
                                 type: 24
                              }
                           })
                        }
                        if(![10].includes(rfq.type)) {
                           dispatch({
                              type: GET_TRIPS,
                              params: {
                                 rfqId: rfq.id,
                                 rfqType: rfq.type,
                                 limit: 1000,
                                 offset: 0
                              }
                           })
                        }
                     } else if(activeView === 2 && rfq.type === 8) {
                        if(this.state.warehouseTrips.length > 0)
                           this.submitRFQ(true);
                     }
                     dispatch({
                        type: GET_TRIPS,
                        params: {
                           rfqId: rfq.id,
                           rfqType: rfq.type,
                           limit: 1000,
                           offset: 0
                        },
                        onSuccess: (data) => {
                           this.setState({ is_dph_enabled: data.is_dph_enabled });
                        }
                     })
                  }
               }
            );
         }
      }
      if (activeView === 1) {
         if(rfq.rfqDetails.serviceType === 3) {
            this.getCourierTrips();
         } else if(!(isAdaniWilmar() || isCargil) && ![10].includes(rfq.type)) {
            dispatch({
               type: GET_TRIPS,
               params: {
                  rfqId: rfq.id,
                  rfqType: rfq.type,
                  limit: 1000,
                  offset: 0
               }
            })
         }
      }
   }

   addCourierTrips = (isSave) => {
      const { dispatch, rfq, courierTrips } = this.props;
      const { courierTripsList, courierOtherCharges, additionalZones } = this.state;

      dispatch({
         type: POST_COURIER_TRIPS,
         data: {
            rfq_id: rfq.id,
            trips: courierTripsList.length > 0 && courierTripsList || courierTrips,
            other_charges_list: courierOtherCharges.length > 0 && courierOtherCharges ||  this.props.courierOtherCharges,
            additional_zone_list: additionalZones.length > 0 && additionalZones ||  this.props.additionalZones || []
         },
         onSuccess: () => {
            this.setState({ courierTripsList: [] , courierOtherCharges: [], additionalZones: []});
            this.getCourierTrips();
            if(!isSave) {
               dispatch({
                  type: CREATE_RFQ,
                  data: rfq.getApiData(),
                  rfq,
               });
            }
         }
      })
   }

   getCourierTrips = (filters = {}) => {
      const { dispatch, rfq, courierZones, match } = this.props;
      dispatch({
         type: GET_COURIER_TRIPS,
         params: {
            rfqId: rfq && rfq.id || match.params.id,
            limit: 1000,
            offset: 0,
            ...filters
         },
         zones: courierZones || [],
         onSuccess: (data) => {
               this.setState({
                  disableSubmitTrips: false
               });
      }
      })
   }

   saveAndClose = () => {
      const { dispatch, rfq } = this.props;
      dispatch({
         type: CREATE_RFQ,
         data: rfq.getApiData(),
         rfq: rfq,
         saveAndClose: true
      });
   }
   setPreviousView = () => {
      const { dispatch } = this.props;
      dispatch({
         type: SET_PREVIOUS_RFQ_VIEW
      });
   }
   onChange = () => {
      const { rfq } = this.props;
      this.setState({
         rfq: rfq
      });
   }
   showAddTrip = (trip) => {

      const { dispatch, rfq, selectedNavBranch } = this.props;
      const user = getUser();
      const params = {
         service_type: rfq.type,
         companyId: user.id
      }
      const data = {
         service_type: 1,
         rfqType: rfq.type
      }
      const newData = {
         rfqType: rfq.type,
         companyId: user.id,
         branchId: (selectedNavBranch || {}).branch_id || user.branchId
      }
      dispatch({ type: GET_VEHICLE_TYPES, params: newData });
      dispatch({ type: GET_VEHICLE_BODY_TYPES, params: newData });
      dispatch({ type: GET_BUSINESS_VOLUMES, data : newData });
      dispatch({
         type: ADD_TRIP_ADDING,
         trip: trip.id ? trip : null,
         addingTrip: true,
      })
      if(rfq.type === 6) {
         dispatch({ type: GET_MULTI_MODE_CONTAINER_LIST });
         dispatch({ type: GET_MULTI_MODE_MOVEMENT_TYPE_LIST });
         dispatch({ type: GET_PLANT_LOCATION_LIST });
         dispatch({ type: GET_DEPOT_LOCATION_LIST });
      }
   }
   hideAddTrip = () => {
      const { dispatch } = this.props;
      dispatch({
         type: ADD_TRIP_ADDING,
         addingTrip: false
      })
      this.setState({ isTripExists: null });
   }
   setActiveView = (activeView) => {
      this.setState({
         activeView
      })
   }
   uploadDocument = (file) => {
      const { dispatch } = this.props;
      dispatch({
         type: UPLOAD_DOCUMENT,
         file,
         onSuccess: () => { this.setState({}) }
      });
   }
   removeDocument = (index) => {
      const { rfq } = this.props;
      rfq.removeDocument(index);
      this.setState({});
   }
   editTrip = (trip) => {
      this.showAddTrip(trip);
   }
   discardRfq = () => {
      const { dispatch, rfq } = this.props;
      if (rfq && rfq.id) {
         dispatch({
            type: DISCARD_RFQ,
            data: {
               rfqId: rfq.id,
               rfqType: rfq.type
            }
         })
      } else {
         localStorage.setItem('teg-component', true);
         location.href = "/admin"
      }
   }
   switchRfqType = () => {
      const { rfq, dispatch } = this.props;
      const rfqType = rfq.type;
      rfq.seRFQType(rfqType === 1 ? 2 : 1);
      dispatch({
         type: CREATE_RFQ,
         data: rfq.getApiData(),
         nextView: false,
         rfq
      })
   }
   getQBR = (params, cb) => {
      const { dispatch } = this.props;
      dispatch({
         type: GET_QBR,
         params,
         onSuccess: (data) => {
            cb(data.qbr);
         }
      })
   }
   componentDidMount() {
      const token = getToken();
      if (window.name && window.name.length > 0 && (!token || (JSON.parse(window.name))['teg-session-token'] !== token) && !(JSON.parse(window.name))['sso-logout-duration']) {
         Object.entries(JSON.parse(window.name)).forEach(([key, value]) => {
             setCookie(key, value, 200);
         });
         location.reload();
     }
      const { dispatch, match, rfq } = this.props;
      const user = getUser();

      this.getBranches();
      dispatch({
        type: GET_SLABS,
      });
      dispatch({
         type: SET_RFQ_ACTIVE_VIEW,
         view: 1
      });
      dispatch({
         type: GET_GROUPS_AND_TRANSPORTERS
      });
      dispatch({
         type: GET_RFQ_DETAIL,
         params: {
            rfqId: match.params.id,
            rfqType: match.params.type
         }
      });
      dispatch({
         type: GET_SECONDARY_UPTO_KM_LIST
      })
      dispatch({ type: GET_SECONDARY_TO_LOCATION });
      dispatch({ type: GET_MOVEMENTS });
      dispatch({ type: GET_MODES });
      dispatch({ type: GET_ZONES });
      dispatch({ type: GET_COURIER_SLABS });
      dispatch({ type: GET_CURRENCY_DETAILS });
      dispatch({ type: GET_CURRENCY_TYPES });
      dispatch({ type: GET_CONTRACT_TENURE_LIST });

      if(EMAMI.includes(user.companyId)) {
         dispatch({
            type: GET_CLUSTER_DETAILS
         });
      }

      if((match.params || {}).type == 3 && isAdaniWilmar()) {
         dispatch({ type: GET_PLANT_LOCATION_LIST });
         dispatch({ type: GET_DEPOT_LOCATION_LIST });
         dispatch({ type:  GET_FUEL_TYPES});
      }
      if(((match.params || {}).type == 1 && isAdaniWilmar()) || CARGIL.includes(user.companyId)) {
         dispatch({ type: GET_FTL_CONTRACT_TYPE });
      }
      dispatch({
         type: GET_CHA_LIST,
         params: {
           companyId: user.companyId
         }
      });
      if ((user && user.isChallengePriceForm) || GREEN_PLY.includes(user.companyId)) {
         dispatch({
            type: GET_AUTO_SUGGEST_LOCATIONS,
            data: GREEN_PLY.includes(user.companyId) ? { companyId: user.companyId } : {}
         });
      }
      if(match.params.type == 5 && HIKAL.includes(user.companyId)) {
         dispatch({type: GET_INCOTERMS_LIST});
         dispatch({ type: GET_COST_HEADS_LIST });
      }
      if(+match.params.type === 8) {
         dispatch({
            type: GET_VENDOR_WITH_MATERIAL_CODE
         });
         dispatch({
            type: GET_PAYMENT_TERMS,
            params: {
               rfqType: match.params.type,
               companyId: user.companyId,
               branchId: user.branchId
            }
         });
         dispatch({
            type: GET_SERVICE_MODE,
            params: {
               rfqType: match.params.type,
               companyId: user.companyId,
               branchId: user.branchId
            }
         });
      }
      if(+match.params.type === 8) {
         dispatch({
            type: GET_VENDOR_WITH_MATERIAL_CODE
         })
      }
      if(+match.params.serviceType === 3) {
         this.getCourierTrips();
      } else {
         dispatch({
            type: GET_TRIPS,
            params: {
               rfqId: match.params.id,
               rfqType: match.params.type,
               limit: 1000,
               offset: 0
            }
         })
      }
      if(match.params.type == 5 && HIKAL.includes(user.companyId)) {
         dispatch({ type: GET_INCOTERMS_LIST });
         this.getCostheads();
      }
      if(CARGIL.includes(user.companyId)) {
         dispatch({ type: GET_SPOT_CONTRACT_REASONS });
         dispatch({ type: GET_ZONE_WISE_DETAILS });
      }
      this.getConstansValues();
   }
   getCostheads = (type = 1) => {
      this.props.dispatch({
         type: GET_COST_HEADS_LIST,
         data: {
            type
         }
      })
   }
   componentDidCatch(e) {
      console.log('ERROR', e);
   }
   showToastError = (message) => {
      const { dispatch } = this.props;
      dispatch({
         type: TOAST_ERROR,
         message
      })
   }
   selectedSubPlants = (selectedSubPlants) => {
      this.setState({
         selectedSubPlant: selectedSubPlants
      }, () => {
         this.props.rfq.setSubPlants(this.state.selectedSubPlant);
      });
   }

   getNetWorkData = (value, type, consignee) => {
      const { dispatch } = this.props;
      if(isDesmet()) {
         if (consignee && consignee.length > 3) {
            dispatch({ type: GET_CONSIGNEE_DETAILS_BY_NAME, params: { type, consignee } });
         } else if (value && value.length > 3) {
            dispatch({ type: GET_CONSIGNEE_DETAILS_BY_NAME, params: { destination: value, type } });
         }
      } else if (value.length > 3) {
         dispatch({ type: GET_NETWORK_DETAILS, param: { name: value } });
      }
   }

   toggleConfirmation = () => {
      this.setState({
        showConfirmation: !this.state.showConfirmation,
     })
   }
   addCourierTrip = (data, type) => {
      if(type === 1) {
         this.setState({
            courierTripsList: data
         })
      } else if(type === 2){
         this.setState({
            courierOtherCharges: data
         })
      } else if(type === 3) {
         this.setState({
            additionalZones: data
         })
      }
   }

   getBranches = () => {
      const { dispatch } = this.props;
      const user = getUser();
      dispatch({
          type: GET_BRANCHES,
          data: {
            companyId: user.id
          }
      })
  }

selectedContractingType= (selectedContractingTypes) => {
   this.setState({
      selectedContracting: selectedContractingTypes
   }, () => {
      this.props.rfq.setContractingType(this.state.selectedContracting);
   });
}

selectedCategoryType= (selectedCategoryTypes) => {
   this.setState({
      selectedContractCategory: selectedCategoryTypes
   }, () => {
      this.props.rfq.setCategoryTypeType(this.state.selectedContractCategory);
   });
}


onChangeProductTrips = (data) => {
   this.setState({ disposalProductTrips: data});
}

postDisposalMaterialTrips = () => {
   const { dispatch, rfq, trips } = this.props;
   const { disposalProductTrips } = this.state;
   dispatch({
      type: ADD_TRIP,
      data: {
         rfq_id: rfq.id,
         trips: disposalProductTrips.length > 0 ? disposalProductTrips : trips
      },
      params: {
         rfqId: rfq.id,
         rfqType: rfq.type
      },
      onSuccess: () => {
         this.setState({ disposalProductTrips: [] });
         dispatch({
            type: CREATE_RFQ,
            data: rfq.getApiData(),
            rfq,
            onSuccess: () => {
               this.fetchTrips();
            }
         });
      }
   });
}

downloadUploadedFile = (fileName) => {
   const { dispatch,rfq } =  this.props;
   dispatch({
      type: DOWNLOAD_UPLOADED_FILE,
      param: {
         fileName,
         companyId:rfq.companyId
      }
   })
}

uploadExistingTripsRemarks = (file) => {
   const { dispatch, rfq, match } = this.props;
   dispatch({
      type: UPLOAD_EXTISTING_TRIPS_REMARKS,
      file,
      params: {
         rfqId: match.params.id,
         type: rfq.rfqDetails.serviceType === 3 ? 1 :(rfq.type==2 || rfq.type==5) ? 3 : 2,
         rfqType: match.params.type,
         withPincode: rfq.rfqDetails.withPincode
      },
      onSuccess: () => {
         this.fetchTrips({ offset: 0, limit: 1000 });
      }
   })
}

downloadExistingTripsRemarks = () => {
   const { dispatch, match, rfq } = this.props;
   dispatch({
      type: DOWNLOAD_EXTISTING_TRIPS_REMARKS_TEMPLATE,
      params:   {
         type: ((rfq.type == 3) ? 9 : ((getUser().showPinCodeDetails) ? 8 : (rfq.rfqDetails.serviceType === 3 ? 1 : (rfq.type==2 || rfq.type==5) ? 3 : 2))),
         rfqId: match.params.id,
         rfqType: match.params.type,
         withPincode: rfq.rfqDetails.withPincode
      }
   })
}

setContainerTrip = (data, errorFlag) => {
   this.setState({
      containerTrips: data,
      containerTripsError: errorFlag
   });
}
   shouldRenderTCAndOtherDocumentsCard = (rfq) => {
      const C1 = isDesmet();

      if (C1) {
         return false;
      }

      return rfq && (rfq.type === 6 ? (rfq.rfqDetails && rfq.rfqDetails.multiLevelMovementType === 1) : true)
   }

   submitRFQ = (isProcurement) => {
      const { dispatch, rfq } = this.props;
      const data = {
         rfq_id: rfq.id,
         trips: this.state.warehouseTrips,
         rfqType: rfq.type
      }
      dispatch({
         type: ADD_TRIP,
         data,
         params: {
            rfqId: rfq.id,
            rfqType: rfq.type
         },
         onSuccess: () => {
            if(!isProcurement) {
               rfq.setIsDraft(false);
               dispatch({
                  type: CREATE_RFQ,
                  data: rfq.getApiData(),
                  rfq
               });
            }
            if(isProcurement) {
               this.fetchTrips();
            }
         }
      });
   }

   onChangeWarehouseTrips = (data) => {
      this.setState({ warehouseTrips: data })
   }

   handleGetScreenInfoDetails = () => {
      return screenInfoDetails.RFQ_VIEW_SCREEN;
   }

   handleAdminUpdate = () => {
      this.setState({ showUpdateModal: true, adminRemark: '' });
   }

   submitAdminUpdate = () => {
      const { dispatch, rfq } = this.props;
      const { adminRemark, originalRfqValues } = this.state;
      const orig = originalRfqValues || {};
      const payload = {
         rfq_id: rfq.id,
         rfqType: rfq.type,
         seekerCompanyId: rfq.companyId,
         reason: adminRemark
      };
      if (rfq.rfqDetails.name !== orig.rfq_name) {
         payload.rfq_name = rfq.rfqDetails.name;
      }
      if (rfq.biddingDetails.pricingBasis !== orig.pricingBasis) {
         payload.pricing_basis = rfq.biddingDetails.pricingBasis;
      }
      if (rfq.biddingDetails.paymentCycle !== orig.paymentCycle) {
         payload.payment_cycle = rfq.biddingDetails.paymentCycle;
      }
      dispatch({
         type: ADMIN_UPDATE_RFQ,
         data: payload,
         onSuccess: () => {
            const { match } = this.props;
            dispatch({
               type: GET_RFQ_DETAIL,
               params: {
                  rfqId: match.params.id,
                  rfqType: match.params.type
               }
            });
         }
      });
      this.setState({ showUpdateModal: false, adminRemark: '' });
   }

   render() {
      const {
         groups,
         transporters,
         activeView,
         creatingRFQ,
         trips,
         documents,
         addingTrip,
         submittingTrip,
         trip,
         tripsCount,
         isTripsLoading,
         submittingDocuments,
         autoSuggestLocations,

         //CONSTANTS
         packingTypes,
         vehicleTypes,
         vehicleBodyTypes,
         paymentCycles,
         businessVolumes,
         slabs,
         pricingBasis,
         productCategories,

         rfq,

         qbr,
         uploadingTrips,
         networkData,
         secondaryToLocations,
         secondaryUpToKmList,
         courierMovements,
         courierModes,
         courierZones,
         courierSlabs,
         courierTrips,
         courierOtherCharges,
         branchesList,
         couriertripsCount,
         currencyDetails,
         rowZones,
         additionalZones,
         colZones,
         YardToYardConstants,
         multiModalMovementTypes,
         containerTypes,
         depotLocationList,
         plantLocationList,
         chaList,
         incotermsList,
         costHeadList,
         selectedNavBranch,
         fuelTypes,
         spotContractReasons,
         contractTenureList,
         ftlContractTypeList,
         clusterDetails,
         zoneWiseDetails,
         vendorBiddingStatus,
         consignorDetails,
         serviceModes,
         paymentTerms,
         vendorWithMaterialCode,
         procurementList,
         warehouseTemplate
      } = this.props;
      const statusbarRFQ = this.state.rfq;
      const isRedirectingToTabs = '/admin';

      let generateRFQName = '';
      if (statusbarRFQ && statusbarRFQ.cargoInfo && statusbarRFQ.cargoInfo.productCategory) {
         const productCategory = productCategories.filter((prod) => { return prod.value === statusbarRFQ.cargoInfo.productCategory });
         const name = (productCategory && productCategory[0]) ? productCategory[0].name : '';
         generateRFQName += name;
      }
      if (statusbarRFQ && statusbarRFQ.rfqDetails && statusbarRFQ.rfqDetails.movementTypeName) {
         generateRFQName = generateRFQName + ' | ' + statusbarRFQ.rfqDetails.movementTypeName;
      }
      if (statusbarRFQ) {
         generateRFQName = generateRFQName + ' | ' + moment(new Date()).format('Do MMMM, YYYY');
      }

      let RouteCodeMissing = [];
      let dieselPriceMissing=[];
      if(isAdaniWilmar() && (rfq && ![6, 9].includes(rfq.type)) && trips.length > 0) {
         if(rfq.type === 3 && (rfq.rfqDetails || {}).secondaryContractType === 2) {
            RouteCodeMissing = trips.filter(trip => !(trip.routeCode.trim()));
         } else if(rfq.type !== 3) {
            const qbrPrice =  (rfq.biddingDetails || {}).pricingBasis === 6 && [6,10].includes(rfq.pricing_bassis_with_qbr_rate_id) && rfq.pricing_basis_qbr_rate;
            RouteCodeMissing = trips.filter(trip => rfq.type === 1 ? (!(trip.routeCode.trim() && trip.vehicleTypeName && trip.stops[0].state && trip.stops[trip.stops.length - 1].state && !trip.is_existing_contract && ((qbrPrice && trip.biddingDetails.qbr) ? Number(trip.biddingDetails.qbr) <= Number(qbrPrice) : true))) : !(trip.routeCode.trim()));
         }
      }
      if(rfq && BEAM.includes(rfq.companyId) && rfq.type === 1) {
         RouteCodeMissing = trips.filter(trip => (!(trip.routeCode.trim() && trip.vehicleTypeName && trip.stops[0].state && trip.stops[trip.stops.length - 1].state)));
      }
      if(rfq && CARGIL.includes(rfq.companyId) && rfq.type === 1) {
         RouteCodeMissing = trips.filter(trip => (!(trip.vehicleTypeName && trip.vehicleBodyTypeName && trip.stops[0].state && ((rfq.rfqDetails || {}).ftlContractType == 2 ? (trip.fromRange && trip.toRange) : ((rfq.rfqDetails || {}).ftlContractType == 3 ? trip.stops[trip.stops.length - 1].city : trip.stops[trip.stops.length - 1].state)))));
      }

      let vehicleCapacityMissing = [];
      if(isAdaniWilmar() && rfq && rfq.type === 1){
         vehicleCapacityMissing = (trips || []).filter(trip => !trip.vehicleCapacity);
      }

      if(rfq && ['737'].includes(rfq.companyId) && rfq.type === 1) {
         RouteCodeMissing = trips.filter(trip => ((rfq.contegory_type || []).find(el => el.name == 'LTC') && !(rfq.rfqDetails || {}).acceptPartialSolution) ? !(trip.biddingDetails.businessVolumeUnit && trip.biddingDetails.businessVolumeValue && trip.from && trip.to && trip.vehicleTypeName && trip.vehicleBodyTypeName) : !(trip.from && trip.to && trip.vehicleTypeName && trip.vehicleBodyTypeName));
      }

      let fromToLocation = [];
      if(rfq && (rfq.type === 3)) {
         fromToLocation = (trips || []).filter(trip => isAdaniWilmar() ? !(trip.from) : !(trip.from && trip.to));
      }

      if(rfq && (rfq.type === 8)) {
         fromToLocation = (this.state.warehouseTrips || []).filter(trip => !(trip.ceiling_price));
      }

      let qbrValue = [];
      if(rfq && GREEN_PLY.includes(rfq.companyId)) {
         qbrValue = (trips || []).filter(trip => !(trip.requiredVehicleCapacity && trip.vehicleTypeName && trip.vehicleBodyTypeName));
      }

      if(rfq && rfq.type === 9) {
         RouteCodeMissing = ((this.state.disposalProductTrips.length > 0 ? this.state.disposalProductTrips : trips) || []).filter(trip => !(trip.transporters && trip.transporters.length));
      }

      if(rfq && rfq.type !== 9 && getUser().tk11_routecode_validation && rfq.type !== 6 && ((isAdaniWilmar()) ? ( rfq && rfq.type === 3 && (rfq.rfqDetails || {}).secondaryContractType === 2) : true)) {
         RouteCodeMissing = trips.filter(trip => !(trip.routeCode.trim()));
      }

      if(rfq && (CENTURY_PLY.includes(rfq.companyId) || ROQUETTE.includes(rfq.companyId)) && rfq.type === 1) {
         RouteCodeMissing = trips.filter(trip => CENTURY_PLY.includes(rfq.companyId) ? !(trip.biddingDetails.businessVolumeValue && trip.vehicleCapacity && trip.vehicleTypeName && trip.vehicleBodyTypeName && trip.sap_vehicle_id) : !trip.biddingDetails.businessVolumeValue);
      }
      let warehouseTripsFilled = (this.state.warehouseTrips || []).length > 0;
      if(rfq && (rfq.type === 8)) {
         (this.state.warehouseTrips || []).map((val, index) => {
            if(!val.ceiling_price) {
               warehouseTripsFilled = false;
            }
         })
      }

      if(rfq && rfq.type === 10) {
         RouteCodeMissing = (this.state.containerTripsError ? [{}] : (this.state.containerTrips || []).filter(trip => !trip.trip_id));
      }
      if(rfq && (BEAM.includes(rfq.companyId))) {
         dieselPriceMissing = trips.filter(trip => BEAM.includes(rfq.companyId) && !(trip.biddingDetails.diesel_price ));
      }

      if(rfq && isDesmet()) {
         fromToLocation = trips.filter(trip => (!((trip.consigners[0] || {}).company_name && (trip.consignees[0] || {}).company_name)));
      }

      return (
         <div className="pr">
            <ScreenTimeTrack
               screenInfoDetailsItem={this.handleGetScreenInfoDetails()}
            />
            {creatingRFQ && <ActionLoader fixed={true} />}
            {submittingTrip && <ActionLoader fixed={true} />}
            {isTripsLoading && <ActionLoader fixed={true} />}
            {submittingDocuments && <ActionLoader fixed={true} />}
            {uploadingTrips && <ActionLoader fixed={true} />}
            {!rfq && <ActionLoader fixed={true} />}
            {rfq && <Sticky>
               {rfq && <Link className="ht-60 flex flex-middle pl-40" to={isRedirectingToTabs}>
                  <BackIcon className="mr-10 fill-theme curP" />
                  <div className="header-dark-color fs-16 fBold">Admin</div>
               </Link>}
               <RFQStatusBar previewMode rfq={statusbarRFQ || rfq} activeView={activeView} setActiveView={this.setActiveView} trips={trips} />
               {![7, 8].includes(rfq.type) ? <>
               {(activeView === 1) && <div className="container">
                  <div className="flex mt-80 mb-80 pr max-wt-650">
                     {activeView === 1 && <div className="flex flex-column flex-1">
                        <div className="mb-20" ref={(e) => { this.rfqDetailsRef = e; }}>
                           <RFQDetails
                              onChange={this.onChange}
                              rfqDetails={rfq.rfqDetails}
                              viewMode={this.viewMode}
                              onAdminRfqNameChange={(val) => this.setState({ adminRfqName: val })}
                              rfqType={rfq.type}
                              rfq={rfq}
                              generateRFQName={generateRFQName}
                              submitted={this.state.rfqDetailsSubmitted}
                              branchesList={this.props.branchesList}
                              allSubPlants={this.props.allSubPlants}
                              selectedSubPlantNames={this.selectedSubPlants}
                              subPlantName={rfq.subplant_name}
                              chaList={chaList}
                              selectedContractingType={this.selectedContractingType}
                              selectedCategoryType ={this.selectedCategoryType}
                              pricingBasis={pricingBasis}
                              fuelTypes = { fuelTypes }
                              selectedNavBranch={ selectedNavBranch }
                              spotContractReasons={ spotContractReasons }
                              contractTenureList={contractTenureList}
                              searchGroupsAndTransporters={this.searchGroupsAndTransporters}
                              ftlContractTypeList = { ftlContractTypeList }
                              vendorBiddingStatus={vendorBiddingStatus}
                           />
                        </div>
                        {![6, 9, 10].includes(rfq.type) && <div className="mb-20">
                           <BiddingDetailsCard viewMode={this.viewMode} onChange={this.onChange} rfqDetails={rfq.rfqDetails} />
                        </div>}
                        {isCoromandel() && <div className="mb-20">
                        <Tk11Details
                           viewMode={this.viewMode}
                           onChange={this.onChange}
                           rfqDetails={rfq.rfqDetails}

                        />
                        </div>}
                        <div className="mb-20" ref={(e) => { this.cargoDetailsRef = e; }}>
                           <CargoInformation
                              onChange={this.onChange}
                              cargoInfo={rfq.cargoInfo}
                              packingTypes={packingTypes}
                              productCategories={productCategories}
                              viewMode={this.viewMode}
                              submitted={this.state.cargoDetailsSubmitted}
                              rfqType={rfq.type}
                              material_packing_list = {rfq.rfqDetails.material_packing_list}
                           />
                        </div>

                           {isDesmet() && <Fragment>
                              <CardWrapper>
                                 <ContactDetails
                                    contact_details={rfq.rfqDetails.contact_details}
                                 />
                              </CardWrapper>
                              <Spacer spacing={"10px"} />
                              <CardT5
                                 supplier_instruction={rfq.rfqDetails.supplier_instruction}
                              />
                           </Fragment>}


                        <div className="mb-20" ref={(e) => { this.biddingDetailsRef = e; }}>
                           <div className="box-shadow ph-20 pv-20 br-5">
                              <div className="fBold fs-22 border-bottom-light lh-40p mb-30">
                                 Bidding Details
                                </div>
                              <BiddingDetails
                                 biddingDetails={rfq.biddingDetails}
                                 onChange={this.onChange}
                                 paymentCycles={paymentCycles}
                                 businessVolumes={businessVolumes}
                                 pricingBasis={pricingBasis}
                                 slabs={slabs}
                                 viewMode={this.viewMode}
                                 viewType="rfq"
                                 rfqServiceType={rfq.rfqDetails.serviceType}
                                 submitted={this.state.biddingDetailsSubmitted}
                                 bidEndTimeValue={rfq.bidEndTimeValue}
                                 systemTime={this.props.systemTime}
                                 rfqType={rfq.type}
                                 rfq={rfq}
                                 incotermsList={incotermsList}
                                 costHeadList={costHeadList}
                              />
                           </div>
                        </div>
                        {this.shouldRenderTCAndOtherDocumentsCard(rfq) &&
                        <div className="mb-20" ref={(e) => { this.documentsRef = e; }}>
                           <DocumentsCard
                              rfqDetails={rfq.rfqDetails}
                              documents={rfq.documents}
                              uploadDocument={this.uploadDocument}
                              viewMode={this.viewMode}
                              removeDocument={this.removeDocument}
                              downloadUploadedFile={this.downloadUploadedFile}
                              submitted={this.state.documentsSubmitted}
                           />
                        </div>}
                        {rfq && (rfq.type === 6 ? (rfq.rfqDetails && rfq.rfqDetails.multiLevelMovementType === 1) : ![9, 10].includes(rfq.type)) &&
                        <div className="mb-20" ref={(e) => { this.transporterDetailsRef = e; }}>
                           <TransportersCard
                              viewMode={this.viewMode}
                              searchGroupsAndTransporters={this.searchGroupsAndTransporters}
                              transporters={transporters}
                              rfq={rfq}
                              groups={groups || []}
                              submitted={this.state.transporterDetailsSubmitted}
                           />
                        </div>}
                     </div>}

                     <img src={LadyImage} alt="lady" className="pf vCenter ml-20 wt-400 ht-200 r-0" />
                  </div>
               </div>}
               {activeView === 2 && <div className="fluid-container">
                  <div className="mt-80 mb-80">
                     <TripTable
                        tripsCount={tripsCount}
                        editTrip={this.editTrip}
                        fetchTrips={this.fetchTrips}
                        showAddTrip={this.showAddTrip}
                        trips={trips || []}
                        offset={this.state.offset}
                        vehicleTypes={vehicleTypes}
                        secondaryToLocations={secondaryToLocations}
                        vehicleBodyTypes={vehicleBodyTypes}
                        isTripsLoading={isTripsLoading}
                        viewMode={this.viewMode}
                        uploadTrips={this.uploadTrips}
                        downloadTripsUrl={null}
                        downloadTrips={this.downloadTrips}
                        tripsType={rfq.rfqDetails.tripsType}
                        addingTrip={addingTrip}
                        autoSuggestLocations={autoSuggestLocations}
                        rfqType={rfq.type}
                        secondaryContractType={rfq.rfqDetails.secondaryContractType}
                        trip={trip}
                        addTrip={this.addTrip}
                        rfqServiceType={rfq.rfqDetails.serviceType}
                        hideAddTrip={this.hideAddTrip}
                        deleteAddedTrip={this.deleteAddedTrip}
                        secondaryUpToKmList={secondaryUpToKmList}
                        addCourierTrip={this.addCourierTrip}
								includesOtherCharges={this.props.rfq.includesOtherCharges}
								otherCosts={this.props.rfq.rfqDetails.otherCosts}
                        courierMovements={courierMovements}
                        courierModes={courierModes}
                        courierZones={courierZones}
                        courierSlabs={courierSlabs}
                        courierTrips={courierTrips}
                        courierOtherCharges={courierOtherCharges}
                        rowZones={rowZones}
                        colZones={colZones}
                        additionalZones={additionalZones}
								rfqBiddingDetails={rfq.biddingDetails}
								rfqDetails={this.props.rfq.rfqDetails}
								courierTatWeight={rfq.rfqDetails.courierTatWeight}
								courierPriceWeight={rfq.rfqDetails.courierPriceWeight}
                        branchesList ={branchesList}
                        couriertripsCount ={couriertripsCount}
                        businessVolumes={businessVolumes}
                        rfq={rfq}
                        transporters={groups}
                        searchGroupsAndTransporters={this.searchGroupsAndTransporters}
                        YardToYardConstants={YardToYardConstants}
                        pricingBasis={pricingBasis}
                        containerTypes={containerTypes}
                        multiModalMovementTypes={multiModalMovementTypes}
                        depotLocationList={depotLocationList}
                        plantLocationList={plantLocationList}
                        currencyTypes={this.props.currencyTypes}
                        rfqTypeLtc = {rfq.rfqDetails.rfqTypeLtc}
                        selectedNavBranch={selectedNavBranch}
                        groups={groups || []}
                        onChangeProductTrips={this.onChangeProductTrips}
                        clusterDetails={clusterDetails}
                        setContainerTrip={this.setContainerTrip}
                        is_dph_enabled={this.state.is_dph_enabled}
                     />
                  </div>
               </div>}
               {activeView === 3 && <div className="fluid-container">
                  <div className="mt-80">
                     <Preview
                        onChange={this.onChange}
                        documents={documents}
                        rfq={rfq}
                        uploadDocument={this.uploadDocument}
                        transporters={transporters}
                        groups={groups}
                        trips={trips || []}
                        vehicleTypes={vehicleTypes}
                        vehicleBodyTypes={vehicleBodyTypes}
                        secondaryToLocations={secondaryToLocations}
                        paymentCycles={paymentCycles}
                        pricingBasis={pricingBasis}
                        productCategories={productCategories}
                        slabs={slabs}
                        businessVolumes={businessVolumes}
                        packingTypes={packingTypes}
                        offset={this.state.offset}
                        tripsCount={tripsCount}
                        editTrip={this.editTrip}
                        showAddTrip={this.showAddTrip}
                        fetchTrips={this.fetchTrips}
                        removeDocument={this.removeDocument}
                        downloadUploadedFile={this.downloadUploadedFile}
                        uploadTrips={this.uploadTrips}
                        viewMode={this.viewMode}
                        tripsType={rfq.rfqDetails.tripsType}
                        systemTime={this.props.systemTime}
                        addingTrip={addingTrip}
                        hideAddTrip={this.hideAddTrip}
                        addTrip={this.addTrip}
                        rfqServiceType={rfq.rfqDetails.serviceType}
                        deleteAddedTrip={this.deleteAddedTrip}
                        secondaryUpToKmList={secondaryUpToKmList}
                        addCourierTrip={this.addCourierTrip}
								allSubPlants={this.props.allSubPlants}
								selectedSubPlant={this.state.selectedSubPlant}
                        selectedSubPlantNames={this.selectedSubPlants}
                        courierTrips={courierTrips}
                        courierMovements={courierMovements}
                        courierModes={courierModes}
                        courierZones={courierZones}
                        courierSlabs={courierSlabs}
                        courierOtherCharges={courierOtherCharges}
                        rowZones={rowZones}
                        colZones={colZones}
                        additionalZones={additionalZones}
                        downloadTrips={this.downloadTrips}
                        rfqBiddingDetails={rfq.biddingDetails}
								courierTatWeight={rfq.rfqDetails.courierTatWeight}
								courierPriceWeight={rfq.rfqDetails.courierPriceWeight}
                        branchesList={branchesList}
                        searchGroupsAndTransporters={this.searchGroupsAndTransporters}
                        YardToYardConstants={YardToYardConstants}
                        containerTypes={containerTypes}
                        multiModalMovementTypes={multiModalMovementTypes}
                        depotLocationList={depotLocationList}
                        plantLocationList={plantLocationList}
                        chaList={chaList}
                        currencyTypes={this.props.currencyTypes}
                        otherCosts={this.props.rfq.rfqDetails.otherCosts}
                        selectedContracting={this.state.selectedContracting}
                        selectedContractingType={this.selectedContractingType}
                        selectedCategoryType ={this.selectedCategoryType}
                        selectedContractCategory={this.state.selectedContractCategory}
                        incotermsList={incotermsList}
                        costHeadList={costHeadList}
                        selectedNavBranch={selectedNavBranch}
                        fuelTypes = { fuelTypes }
                        onChangeProductTrips={this.onChangeProductTrips}
                        spotContractReasons = { spotContractReasons }
                        contractTenureList={contractTenureList}
                        ftlContractTypeList={ ftlContractTypeList }
                        clusterDetails={clusterDetails}
                        zoneWiseDetails={zoneWiseDetails}
                        vendorBiddingStatus={vendorBiddingStatus}
                        setContainerTrip={this.setContainerTrip}
                     />
                  </div>
               </div>}
               {addingTrip && rfq.type === 1 && <AddTrip
                  disablePlacementTime={(rfq.rfqDetails.contractTenureTo - rfq.rfqDetails.contractTenureFrom) <= 3600 * 1000 * 24 * 7}
                  rfqType={rfq.type}
                  rfqServiceType={rfq.rfqDetails.serviceType}
                  addTrip={this.addTrip}
                  hideAddTrip={this.hideAddTrip}
                  deleteTrip={this.deleteTrip}
                  trip={trip}
                  vehicleTypes={vehicleTypes}
                  vehicleBodyTypes={vehicleBodyTypes}
                  paymentCycles={paymentCycles}
                  pricingBasis={pricingBasis}
                  slabs={slabs}
                  businessVolumes={businessVolumes}
                  productCategories={productCategories}
                  viewMode={this.viewMode}
                  qbr={qbr}
                  getQBR={this.getQBR}
                  showError={this.showToastError}
                  rfqBiddingDetails={rfq.biddingDetails}
                  autoSuggestLocations={autoSuggestLocations}
                  networkData={networkData}
                  getNetWorkData={this.getNetWorkData}
                  isTripExists={this.state.isTripExists}
                  resetTripStatus={this.resetTripStatus}
                  systemTime={this.props.systemTime}
                  rfq={rfq}
                  clusterDetails={clusterDetails}
                  zoneWiseDetails={zoneWiseDetails}
                  ftlContractTypeList={ftlContractTypeList}
                  consignorDetails={consignorDetails}
               />}
               {addingTrip && (rfq.type === 2 || rfq.type === 5) && <MultiModeAddTrip
                  disablePlacementTime={(rfq.rfqDetails.contractTenureTo - rfq.rfqDetails.contractTenureFrom) <= 3600 * 1000 * 24 * 7}
                  rfqType={rfq.type}
                  rfqServiceType={rfq.rfqDetails.serviceType}
                  addTrip={this.addTrip}
                  hideAddTrip={this.hideAddTrip}
                  deleteTrip={this.deleteTrip}
                  trip={trip}
                  vehicleTypes={vehicleTypes}
                  vehicleBodyTypes={vehicleBodyTypes}
                  paymentCycles={paymentCycles}
                  pricingBasis={pricingBasis}
                  slabs={slabs}
                  businessVolumes={businessVolumes}
                  productCategories={productCategories}
                  viewMode={this.viewMode}
                  qbr={qbr}
                  getQBR={this.getQBR}
                  showError={this.showToastError}
                  rfqBiddingDetails={rfq.biddingDetails}
                  autoSuggestLocations={autoSuggestLocations}
                  networkData={networkData}
                  getNetWorkData={this.getNetWorkData}
                  isTripExists={this.state.isTripExists}
                  resetTripStatus={this.resetTripStatus}
                  multiLevelMovementType={rfq.rfqDetails.multiLevelMovementType}
                  otherCosts={rfq.rfqDetails.otherCosts}
                  systemTime={this.props.systemTime}
                  currencyDetails={this.props.currencyDetails}
                  currencyTypes={this.props.currencyTypes}
                  rfq={rfq}
                  costHeadList={costHeadList}
               />
               }
            </>
            :
            <Procurement
               rfq={rfq}
               onChange={this.onChange}
               viewMode={this.viewMode}
               systemTime={this.props.systemTime}
               uploadDocument={this.uploadDocument}
               removeDocument={this.removeDocument}
               downloadUploadedFile={this.downloadUploadedFile}
               documents={rfq.documents}
               warehouseTemplate={warehouseTemplate}
               transporters={transporters}
               groups={groups || []}
               onChangeWarehouseTrips={this.onChangeWarehouseTrips}
               vendorWithMaterialCode={vendorWithMaterialCode}
               serviceModes={serviceModes}
               paymentTerms={paymentTerms}
               activeView={activeView}
               procurementList={procurementList}
            />}
            </Sticky>}
            {rfq && !this.viewMode && <RFQBottomSticky
               viewMode={this.viewMode}
               discardRfq={this.discardRfq}
               saveAndClose={this.saveAndClose}
               setNextView={this.setNextView}
               activeView={activeView}
               setPreviousView={this.setPreviousView}
               disableSubmitTrips={this.state.disableSubmitTrips || fromToLocation.length > 0 || RouteCodeMissing.length > 0 || qbrValue.length > 0 || vehicleCapacityMissing.length > 0 || (isBeamS() && dieselPriceMissing.length > 0)}
               toggleConfirmation={this.toggleConfirmation}
               serviceType={rfq.rfqDetails.serviceType}
               addCourierTrips={this.addCourierTrips}
               rfqType={rfq.type}
               addingTrip={addingTrip}
               rfq={rfq}
               warehouseTripsFilled={warehouseTripsFilled}
               downloadExistingTripsRemarks={this.downloadExistingTripsRemarks}
               uploadExistingTripsRemarks= {this.uploadExistingTripsRemarks}
               tripsCount={tripsCount}
               procurementList={procurementList}
            />}
            {this.state.showConfirmation &&
            <ConfirmationPopup
              text="Are You Sure To Proceed?"
              onConfirm={() => {
                 this.toggleConfirmation();
                 this.setNextView();
              }}
               onCancel={this.toggleConfirmation}
             />}
            <a href={this.state.uploadTripsUrl} className="dNone" ref={(ref) => { this.uploadTripsButton = ref; }}>Upload Trips</a>
            {rfq && <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: '#fff', borderTop: '1px solid #e0e0e0', padding: '12px 24px', display: 'flex', justifyContent: 'flex-end', zIndex: 1000 }}>
               <button
                  className="button-classic"
                  onClick={this.handleAdminUpdate}
               >
                  Update
               </button>
            </div>}
            {this.state.showUpdateModal && (
               <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
                  <div style={{ background: '#fff', borderRadius: 8, padding: '28px 32px', width: 460, boxShadow: '0 4px 24px rgba(0,0,0,0.18)' }}>
                     <div className="fBold fs-18 header-dark-color mb-20">Update RFQ</div>
                     <div className="fs-14 table-text-color mb-8">Remarks <span style={{ color: '#e53935' }}>*</span></div>
                     <textarea
                        rows={4}
                        value={this.state.adminRemark}
                        onChange={(e) => this.setState({ adminRemark: e.target.value })}
                        placeholder="Enter remarks..."
                        style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', borderRadius: 5, border: '1px solid #d0d0d0', fontSize: 14, resize: 'vertical' }}
                     />
                     <div className="flex flex-end mt-20" style={{ gap: 12 }}>
                        <button
                           className="button-classic-secondary"
                           style={{ marginRight: 8 }}
                           onClick={() => this.setState({ showUpdateModal: false, adminRemark: '' })}
                        >
                           Cancel
                        </button>
                        <button
                           className="button-classic"
                           disabled={!this.state.adminRemark.trim()}
                           style={{ opacity: this.state.adminRemark.trim() ? 1 : 0.5, cursor: this.state.adminRemark.trim() ? 'pointer' : 'not-allowed' }}
                           onClick={this.submitAdminUpdate}
                        >
                           Submit
                        </button>
                     </div>
                  </div>
               </div>
            )}
         </div>
      );
   }
}

const mapStateToProps = ({ constants, rfq, common, contracting }) => {
   return {
      rfq: rfq.createdRFQ || null,
      activeView: rfq.activeView,
      creatingRFQ: rfq.createRFQ.dataSubmitting || rfq.deleteAddedTrip,
      trips: rfq.trips.data,
      addingTrip: rfq.trips.addingTrip,
      submittingTrip: rfq.trips.dataSubmitting,
      documents: rfq.documents.data || [],
      submittingDocuments: rfq.documents.dataSubmitting,
      trip: rfq.trips.trip,
      tripsCount: rfq.trips.tripsCount,
      isTripsLoading: rfq.trips.dataLoading || rfq.courierTrips.dataLoading,
      uploadingTrips: rfq.uploadTemplates.dataSubmitting || contracting.loader,
      allLocations: rfq.allLocations || [],
      autoSuggestLocations: (rfq.autoSuggestLocations && rfq.autoSuggestLocations.list && rfq.autoSuggestLocations.list.length) ? rfq.autoSuggestLocations.list : ((Object.keys(rfq.autoSuggestLocations || {}).length > 0 && rfq.autoSuggestLocations) || []),

      //CONSTANTS
      groups: constants.groups || [],
      transporters: constants.transporters || [],
      packingTypes: constants.packingTypes || [],
      vehicleTypes: constants.vehicleTypes || [],
      vehicleBodyTypes: constants.vehicleBodyTypes || [],
      branchesList: constants.branchesList || [],

      paymentCycles: constants.paymentCycles || [],
      businessVolumes: constants.businessVolumes || [],
      pricingBasis: constants.pricingBasis || [],
      slabs: constants.slabs || [],
      productCategories: constants.productCategories || [],

      qbr: rfq.trips.qbr,
      allSubPlants: rfq.allSubPlants ? rfq.allSubPlants : [],
      networkData: rfq.networkData || [],

      systemTime: common.systemTime,
      secondaryToLocations: constants.secondaryToLocations || [],
      secondaryUpToKmList: constants.secondaryUpToKmList || [],
      courierMovements: constants.courierMovements || [],
      courierModes: constants.courierModes || [],
      courierZones: constants.courierZones || [],
      courierSlabs: constants.courierSlabs || [],
      courierTrips: rfq.courierTrips.data || [],
      couriertripsCount: rfq.courierTrips.tripsCount,
      courierOtherCharges: rfq.courierTrips.otherCharges || [],
      currencyDetails: constants.currencyDetails || [],
      rowZones: rfq.courierTrips.rowZones || [],
      additionalZones: rfq.courierTrips.additionalZones || [],
      colZones: rfq.courierTrips.colZones || [],
      YardToYardConstants: constants.YardToYardConstants || {},
      containerTypes: constants.containerTypes || [],
      multiModalMovementTypes: constants.multiModalMovementTypes || [],
      plantLocationList: constants.plantLocationList || [],
      depotLocationList: constants.depotLocationList || [],
      chaList: constants.chaList || [],
      currencyTypes: constants.currencyTypes || [],
      incotermsList: constants.incotermsList || [],
      costHeadList: constants.costHeadList || [],
      selectedNavBranch: constants.selectedNavBranch || {},
      fuelTypes: constants.fuelTypes || [],
      spotContractReasons: constants.spotContractReasons || [],
      contractTenureList: constants.contractTenureList || [],
      ftlContractTypeList: constants.ftlContractTypeList || [],
      clusterDetails: constants.clusterDetails || [],
      zoneWiseDetails: constants.zoneWiseDetails || [],
      vendorBiddingStatus: constants.vendorBiddingStatus || [],
      consignorDetails: constants.consignorDetails || [],
      serviceModes: constants.serviceModes || [],
      paymentTerms: constants.paymentTerms || [],
      vendorWithMaterialCode: constants.vendorWithMaterialCode || [],
      procurementList: rfq.trips.procurementList || [],
      warehouseTemplate: constants.warehouseTemplate || [],
   }
};

export default connect(mapStateToProps)(AdminRFQView);
